import React from 'react';
import '../../css/home.css';
import Navbar from '../../components/Navbar';
import Questions from '../../components/Questions';
import SectionHeader from '../../components/SectionHeader';

const Home = () => {
    return (
        <div className="home-container">
            <Navbar />
            <div className="homepage">
                <SectionHeader className = 'page-header' icon="" title="Equalizer Questions" />
                <Questions />
            </div>
        </div>
    );
};

export default Home;